import { getInstance } from "@/auth/";

export default (to, from, next) => {
  // Getting current Auth Instance
  const authService = getInstance();

  // If Authservice is finished loading and is authenticated then get Token and Init Auth
  if (!authService.loading) {
    fn(authService.isAuthenticated, to);
  } else {
    // Else wait till finish loading and add a listener for "isAuthenticated"
    authService.$watch("loading", loading => {
      if (loading === false) {
        fn(authService.isAuthenticated, to);
      }
    });
  }

  function fn(isAuthenticated, to) {
    if (isAuthenticated) {
      return next();
    } else if (isAuthenticated && !to.meta.offlineAvailability) {
      next("/login");
    } else {
      return next();
    }
  }
};
